
<template>
  <div>
    <OrderResume :order="order" solution="retail"></OrderResume>
  </div>
</template>

<script>

export default {
  name: 'FinishRetailOrder',
  components: {
    OrderResume: () => import('../../shared/OrderResume.vue'),
  },
  props: {
    order: {
      type: Object,
    },
    dialog: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    client_name(){
      let name = null
      if (this.order.is_new_client){
        name = this.order.new_client_data.name
      } else if(this.order.is_default_client){
        name = 'Cliente final'
      }else {
        name = this.order.client_name
      }
      return name
    },
    howManyItems() {
      let units = 0
      units = this.order.items_attributes.reduce((all, one) => Number(one.total_units_aux.replace(/,/g, '')) + all, 0)

      return units
    },

    totalPrice() {
      let total = 0
      total = this.order.items_attributes.reduce((all, one) => Number(one.total_sell_price) + all, 0)

      return total
    },
  },
}
</script>